
import '../App.css';
import Switch from "react-switch";
import './DeviceToggle.css'; // Import local CSS for styling

function DeviceToggle({ totalDevices = 30, handleToggle, showOnline }) {
  return (
    <div className="device-toggle-wrapper">
      <div className="switch-container">
        <Switch
          checkedIcon={false}
          uncheckedIcon={false}
          onChange={handleToggle}
          checked={showOnline}
        />
        <div className="device-count-hover">
          Total: {totalDevices} Devices
        </div>
      </div>
    </div>
  );
}

export default DeviceToggle;
